import { render, staticRenderFns } from "./AlertaVigenciaCompetenciasBasicasPersonalComponent.vue?vue&type=template&id=33f42810"
import script from "./AlertaVigenciaCompetenciasBasicasPersonalComponent.vue?vue&type=script&lang=js"
export * from "./AlertaVigenciaCompetenciasBasicasPersonalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports